import { createAction, props } from '@ngrx/store';
import { DisruptionMessage, LatLng } from '@ridango/core';
import { HttpErrorResponse } from '@angular/common/http';
import {
    ExploreMapRoute,
    Itinerary,
    JourneyMapPlan,
    PlannerError,
    Route,
    RouteGroups,
    SearchRecentlyJourney,
    Stop,
    StopMarker,
    TripDetails
} from '../open-trip-planner.model';
import { JourneyPlannerFilter } from '../journey-planner-filter.model';

export const getAllRoutes = createAction('[OTP]: Get all routes');
export const getAllRoutesSuccess = createAction('[OTP]: Get all routes success', props<{ routes: Route[] }>());

export const getAllRoutesGroups = createAction('[OTP]: Get all routes groups');
export const getAllRoutesGroupsSuccess = createAction(
    '[OTP]: Get all routes groups success',
    props<{ routesGroups: RouteGroups[] }>()
);

export const getAllAlerts = createAction('[Alerts] Load All Alerts');

export const getAllAlertsSuccess = createAction(
    '[Alerts] Load All Alerts Success',
    props<{ alerts: DisruptionMessage[] }>()
);

export const getAllAlertsFailure = createAction(
    '[Alerts] Load All Alerts Failure',
    props<{ error: HttpErrorResponse }>()
);

export const getAllStops = createAction('[OTP]: Get all stops');
export const getAllStopsSuccess = createAction('[OTP]: Get all stops success', props<{ stops: Stop[] }>());

export const setCurrentLocation = createAction(
    '[OTP]: Set current location',
    props<{ coordinates: LatLng; hasError: boolean }>()
);

export const setSearchOrigin = createAction(
    '[OTP]: Set search origin',
    props<{
        name?: string;
        coordinates?: LatLng;
        isCurrentLocation?: boolean;
        isLocationFromMap?: boolean;
        municipalityName?: string;
        fromStopId?: number;
    }>()
);

export const setSearchDestination = createAction(
    '[OTP]: Set search destination',
    props<{
        name?: string;
        coordinates?: LatLng;
        isCurrentLocation?: boolean;
        isLocationFromMap?: boolean;
        municipalityName?: string;
        toStopId?: number;
    }>()
);

export const clearSearch = createAction('[OTP]: Clear search');

export const getPlan = createAction(
    '[OTP]: Get plan',
    props<{
        toPlace: { lat: number; lng: number };
        fromPlace: { lat: number; lng: number };
        loadMore?: string;
        filters?: any;
        searchDateAndTime?: any;
        fromPointType?: string;
        toPointType?: string;
        expandSearchWindow?: boolean;
    }>()
);
export const getPlanSuccess = createAction('[OTP]: Get plan success', props<{ itineraries: Itinerary[] }>());
export const getPlanError = createAction('[OTP]: Get plan error', props<{ error: PlannerError }>());

export const setSearchDisabled = createAction('[OTP]: Set search disabled', props<{ disabled: boolean }>());

export const setSelectedItineraryForDetails = createAction(
    '[OTP]: Set selected itinerary for details',
    props<{ itinerary: Itinerary }>()
);

export const setJourneyMapPlan = createAction(
    '[OTP]: Set journey plan for map',
    props<{ journeyMapPlan: JourneyMapPlan }>()
);

export const setJourneyPlannerFilters = createAction(
    '[OTP]: Set journey planner filters',
    props<{ filters: JourneyPlannerFilter }>()
);

export const setExploreMapStops = createAction(
    '[OTP]: Set explore map stops',
    props<{ exploreMapStops: StopMarker[] }>()
);

export const setExploreMapRoute = createAction(
    '[OTP]: Set explore map route',
    props<{
        exploreMapRoute: ExploreMapRoute | null;
    }>()
);

export const swapSearchOriginAndDestination = createAction('[OTP]: Swap plan search origin and destination');

export const setSearchDateAndTime = createAction(
    '[OTP]: Set search date and time',
    props<{ date: string; time: string; arrive: boolean }>()
);

export const getAllSearchRecentlyJourneys = createAction('[OTP]: Get all search recently journeys');
export const setSearchRecentlyJourneys = createAction(
    '[OTP]: Set search recently journeys',
    props<{
        result: Array<SearchRecentlyJourney>;
    }>()
);

export const addSearchRecentlyJourney = createAction(
    '[OTP]: Add search recently journey',
    props<SearchRecentlyJourney>()
);

export const addSearchRecentlyJourneyToStorage = createAction(
    '[OTP]: Add search recently journey to storage',
    props<SearchRecentlyJourney>()
);

export const clearSearchRecentlyJourneys = createAction('[OTP]: Clear search recently journeys');
export const clearSearchRecentlyJourneysFromStorage = createAction(
    '[OTP]: Clear search recently journeys from storage'
);

export const getNearbyStops = createAction(
    '[OTP]: Get nearby stops',
    props<{ latitude: number; longitude: number; nearbyRadiusMeters: number }>()
);
export const getNearbyStopsSuccess = createAction('[OTP]: Get nearby stops success', props<{ nearbyStops: Stop[] }>());
export const getNearbyStopsError = createAction('[OTP]: Get nearby stops error');

export const loadTripsByRouteId = createAction('[OTP] Load Trips By RouteId', props<{ routeId: string }>());

export const loadTripsByRouteIdSuccess = createAction(
    '[OTP] Load Trips By RouteId Success',
    props<{ trips: TripDetails[] }>()
);

export const loadTripsByRouteIdFailure = createAction('[OTP] Load Trips By RouteId Failure', props<{ error: any }>());

export const clearPlanResults = createAction('[OTP]: Clear plan results');
